export default __webpack_public_path__ + "static/media/close.fcdc7442.svg";